import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { API_ENDPOINTS } from '../Config/api';
import isPasswordValid from '../Utils/isPasswordValid';
import { Icon } from '../Components/UI/Icon';
import PasswordRequirements from '../Components/PasswordRequirements';

export default function SetFirstPassword() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [showPwd, setShowPwd] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg('');

        if (password !== confirm) {
            setErrorMsg('Le password non coincidono');
            return;
        }

        if (!isPasswordValid(password)) {
            setErrorMsg('La password non soddisfa i requisiti di sicurezza');
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(API_ENDPOINTS.changePasswordByToken, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(
                    {
                        token: token,
                        new_password: password
                    }),
            });

            if (res.ok) {
                setSuccess(true);
                setTimeout(() => navigate('/'), 1500);
            } else {
                const data = await res.json();
                setErrorMsg(data.detail || 'Errore generico');
            }
        } catch (e) {
            setErrorMsg('Errore di rete');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen  flex flex-col gap-3 items-center justify-center bg-gray-50 px-4">
            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded shadow-md space-y-6 relative"
            >
                <h2 className="text-xl font-bold text-gray-800">Imposta la tua password</h2>



                {/* Griglia a due colonne */}
                <div className="flex gap-14">
                    {/* Colonna sinistra: input */}
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm text-gray-700 mb-1">Nuova password</label>
                            <div className="relative">
                                <input
                                    type={showPwd ? 'text' : 'password'}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:ring-blue-300 pr-10"
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        if (errorMsg) setErrorMsg('');
                                    }}

                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPwd(prev => !prev)}
                                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                                >
                                    <Icon name={showPwd ? 'eye' : 'eyeslash'} />
                                </button>
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm text-gray-700 mb-1">Conferma password</label>
                            <div className="relative">
                                <input
                                    type={showConfirm ? 'text' : 'password'}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:ring-blue-300 pr-10"
                                    value={confirm}
                                    onChange={(e) => {
                                        setConfirm(e.target.value);
                                        if (errorMsg) setErrorMsg('');
                                    }}

                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirm(prev => !prev)}
                                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                                >
                                    <Icon name={showConfirm ? 'eye' : 'eyeslash'} />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Colonna destra: validazione */}

                    <PasswordRequirements password={password} />
                </div>

                {/* Bottone */}
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded disabled:opacity-50"
                >
                    {loading ? 'Salvataggio...' : 'Conferma'}
                </button>
                {errorMsg && <p className="text-red-600 absolute -bottom-7 right-0 left-0  text-sm text-center">{errorMsg}</p>}
                {success && <p className="text-green-600 absolute -bottom-7 right-0 left-0 text-sm text-center">Password aggiornata!</p>}
            </form>
        </div>
    );
}
